import { AlertTriangle } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";

// Pacote prioritário — inadimplência/bloqueio, item 28 — padrão reusável
// para observações de status excepcionais (ex.: "Pago — baixa manual" com
// o boleto/PIX externo ainda aguardando no provedor). Antes: a frase
// completa ficava sempre visível na linha da tabela, poluindo a leitura.
// Agora: só o ícone ⚠ + "DETALHE" (clicável) aparecem inline; o texto
// completo só some num popover compacto, sob demanda.
export default function StatusDetalhe({ children, testId }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-1 text-xs align-middle hover:underline focus:outline-none"
          data-testid={testId}
        >
          <AlertTriangle size={12} className="text-amber-500 shrink-0" />
          <span className="text-blue-600 font-medium">DETALHE</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 text-sm text-slate-700">{children}</PopoverContent>
    </Popover>
  );
}
